import { useQuery } from "@tanstack/react-query";
import { getSuggestedHouseContentsInsuranceAmount } from "Api/price";
import { isDefined } from "Utils/functions";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useDebounce } from "use-debounce";
import { HouseContentsCalculatorFormValues } from "./interfaces";

export const useCalculateInsuranceAmountQuery = (): ReturnType<
  typeof useQuery<number | undefined | null>
> => {
  const formProps = useFormikContext<HouseContentsCalculatorFormValues>();
  const [searchParams] = useDebounce(
    [
      formProps.values.rooms,
      formProps.values.people,
      formProps.values.standard,
    ],
    300,
  );
  const query = useQuery({
    queryKey: [
      "HouseContentsCalculatorSuggestedInsuranceAmount",
      ...searchParams,
    ],
    queryFn: () => {
      if (formProps.values.standard && formProps.isValid) {
        return getSuggestedHouseContentsInsuranceAmount({
          rooms: Number(formProps.values.rooms),
          people: Number(formProps.values.people),
          houseContentsStandard: formProps.values.standard,
        });
      }
      return Promise.resolve(null);
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const calculatedSuggestedInsuranceAmount = query.data;

  useEffect(() => {
    if (isDefined(calculatedSuggestedInsuranceAmount)) {
      formProps.setFieldValue(
        "suggestedInsuranceAmount",
        calculatedSuggestedInsuranceAmount,
      );
    }
  }, [calculatedSuggestedInsuranceAmount]);

  return query;
};
